<template>
  <TooltipProvider :delayDuration="0">
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          class="hover:cursor-default bg-white dark:bg-gray-950 border border-blue-400 rounded-full py-0.5 px-2.5 inline-flex items-center"
          :tabindex="focusable ? 0 : -1"
          :aria-hidden="!focusable"
        >
          <span class="text-blue-400 text-sm font-normal leading-none">
            Beta
          </span>
        </div>
      </TooltipTrigger>
      <TooltipContent class="max-w-[300px] text-center">
        <p>{{ tooltipContent }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup lang="ts">
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'

withDefaults(
  defineProps<{
    focusable?: boolean
  }>(),
  {
    focusable: false,
  }
)

const tooltipContent = 'This new feature is in active development. Your feedback will help us improve it.'
</script>

<style scoped>
span.bg-clip-text {
  -webkit-text-fill-color: transparent;
}
</style>